<script setup>
import { defineProps, useSlots } from 'vue'

import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

let slots = useSlots()

const props = defineProps({
  title: String,
  content: String,
  statuscode: Number,
  raw: {
    type: Boolean,
    default: false
  },
  pre: {
    type: Boolean,
    default: false
  }
});

let data = {}

if (props.raw) {
  data = slots.default()[0].children
} else {
  data = JSON.parse(slots.default()[0].children)
}
</script>

<template>
  <div class="block mb-3">
    <div class="title">
      <span v-if="statuscode >= 200 && statuscode < 300" class="method" style="color: var(--color-success-text);">{{statuscode}}</span>
      <span v-if="statuscode >= 300 && statuscode < 400" class="method" style="color: var(--color-warning-text);">{{statuscode}}</span>
      <span v-if="statuscode >= 400 && statuscode < 500" class="method" style="color: var(--color-error-text);">{{statuscode}}</span>
      {{ props.title }}
    </div>
    <div class="content">
      <div v-if="raw">
        <pre v-if="pre">{{data}}</pre>
        <div v-else>{{data}}</div>

      </div>
      <vue-json-pretty v-else :data="data" style="overflow: auto; max-height: 600px;"/>
    </div>
  </div>
</template>

<style scoped>
.block {
  border-radius: var(--radius-lg);
  background-color: var(--surface-sunken);
  overflow: hidden;
}

.method {
  font-weight: 600;
  font-size: .8rem;
  margin-right: .5rem;
}

.block .title {
  padding: .6rem .9rem;
  color: var(--text-secondary);
  font-size: var(--fs-sm);
  font-weight: 600;
  letter-spacing: 0.02em;
  border-bottom: 1px solid var(--border-subtle);
}

.block .content {
  padding: .9rem;
}

.block :deep(.vjs-tree) {
  font-family: var(--font-heading);
}

::-webkit-scrollbar-thumb {
  background-color: var(--border);
  border-radius: var(--radius-xl);
  border: 6px solid transparent;
  background-clip: content-box;
}
</style>
